import Image from 'next/image';
import React from 'react';
import {useI18n} from '@udemy-v2/i18n';

import {PageForType} from '../../types/page';

import styles from './stats.module.scss';

interface StatsProps {
    pageFor: PageForType;
}

export const Stats: React.FC<StatsProps> = ({pageFor}) => {
    const {gettext} = useI18n();
    const STATS_DATA = {
        pp: [
            {
                title: '26K+',
                text: gettext('top-rated courses'),
                hasStar: false,
            },
            {
                title: '100K+',
                text: gettext('learners'),
                hasStar: false,
            },
            {
                title: '4.4',
                text: gettext('average course rating'),
                hasStar: true,
            },
            {
                title: '17K+',
                text: gettext('business customers'),
                hasStar: false,
            },
        ],
        mx: [
            {
                title: '250K',
                text: gettext('courses'),
                hasStar: false,
            },
            {
                title: '85K',
                text: gettext('instructors'),
                hasStar: false,
            },
            {
                title: '1B+',
                text: gettext('enrollments since 2010'),
                hasStar: false,
            },
            {
                title: '17K+',
                text: gettext('business customers'),
                hasStar: false,
            },
        ],
    } as const;

    const stats = STATS_DATA[pageFor];

    return (
        <div className={styles.container}>
            <div className={styles.numbers}>
                {stats.map((stat, index) => (
                    <div key={index} className={styles.number}>
                        <div className={styles.numberTitle}>
                            {stat.title}
                            {stat.hasStar && (
                                <Image
                                    src="/indeed/stats/rating-star.svg"
                                    alt="star"
                                    className={styles.rating_star}
                                    width={24}
                                    height={24}
                                />
                            )}
                        </div>
                        <p className={styles.numberText}>{stat.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};
